import React, { Fragment, useState, useEffect } from 'react'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

// import MySelect from '../common/select'
// import DateRangePicker from '@wojtekmaj/react-daterange-picker';
import tools from "../../components/tools/tools";
import FormEditarCarnet from './mesa_form_editar'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

// Use a placeholder for the background color in the SVG template
const printerIconSvgTemplate = `
<svg version="1.1" id="printer" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
     viewBox="0 0 100 100" enable-background="new 0 0 100 100" xml:space="preserve">
<g id="printer-printer">
    <g id="printer-back">
        <rect fill="{{ICON_BACKGROUND_COLOR}}" width="100" height="100"/>
    </g>
    <g id="printer-printer_1_">
        <g>
            <path fill="#000000" d="M65.4795,77.6611h-30.958c-0.5523,0-1-0.4472-1-1V60.9014c0-0.5528,0.4477-1,1-1c0.5522,0,1,0.4472,1,1
                v14.7597h28.958V60.9014c0-0.5528,0.4482-1,1-1c0.5518,0,1,0.4472,1,1v15.7597C66.4795,77.2139,66.0313,77.6611,65.4795,77.6611
                L65.4795,77.6611z"/>
        </g>
        <g>
            <path fill="#000000" d="M65.4795,44.792c-0.5518,0-1-0.4473-1-1V24.3389h-28.958V43.792c0,0.5527-0.4478,1-1,1
                c-0.5523,0-1-0.4473-1-1V23.3389c0-0.5528,0.4477-1,1-1h30.958c0.5518,0,1,0.4472,1,1V43.792
                C66.4795,44.3447,66.0313,44.792,65.4795,44.792L65.4795,44.792z"/>
        </g>
        <g>
            <path fill="#000000" d="M74.9932,66.1836h-7.6729c-0.4375,0-0.8242-0.2842-0.9551-0.7022l-1.1757-3.7646
                c-0.6377-2.0352-2.7598-3.6914-4.7286-3.6914H39.541c-1.9687,0-4.0903,1.6562-4.7295,3.6933l-1.1723,3.7627
                c-0.1299,0.418-0.5171,0.7022-0.9546,0.7022h-7.6748c-1.6597,0-3.0098-1.417-3.0098-3.1592V46.9551
                c0-1.7432,1.3501-3.1612,3.0098-3.1612h49.9834c1.6582,0,3.0068,1.418,3.0068,3.1612v16.0693
                C78,64.7666,76.6514,66.1836,74.9932,66.1836L74.9932,66.1836z M68.0557,64.1836h6.9375c0.5556,0,1.0068-0.5195,1.0068-1.1592
                V46.9551c0-0.6406-0.4512-1.1612-1.0068-1.1612H25.0098c-0.5567,0-1.0098,0.5206-1.0098,1.1612v16.0693
                c0,0.6397,0.4531,1.1592,1.0098,1.1592h6.9389l0.9541-3.0625c0.9121-2.9053,3.7657-5.0957,6.6382-5.0957h20.9199
                c2.8731,0,5.7276,2.1904,6.6377,5.0947L68.0557,64.1836L68.0557,64.1836z"/>
        </g>
        <g>
            <path fill="#000000" d="M58.3096,62.96H41.6904c-0.5522,0-1-0.4473-1-1c0-0.5528,0.4478-1,1-1h16.6192c0.5517,0,1,0.4472,1,1
                C59.3096,62.5127,58.8613,62.96,58.3096,62.96L58.3096,62.96z"/>
        </g>
        <g>
            <path fill="#000000" d="M58.3096,67.709H41.6904c-0.5522,0-1-0.4473-1-1c0-0.5528,0.4478-1,1-1h16.6192c0.5517,0,1,0.4472,1,1
                C59.3096,67.2617,58.8613,67.709,58.3096,67.709L58.3096,67.709z"/>
        </g>
        <g>
            <path fill="#000000" d="M58.3096,72.4561H41.6904c-0.5522,0-1-0.4473-1-1c0-0.5528,0.4478-1,1-1h16.6192c0.5517,0,1,0.4472,1,1
                C59.3096,72.0088,58.8613,72.4561,58.3096,72.4561L58.3096,72.4561z"/>
        </g>
        <g>
            <path fill="#000000" d="M69.7852,44.8564c-0.5528,0-1-0.4472-1-1v-3.9443l-2.9532-0.001c-0.5527,0-1-0.4482-1-1
                c0-0.5527,0.4473-1,1-1l0,0l3.9532,0.001c0.5527,0,1,0.4483,1,1v4.9443C70.7852,44.4092,70.3379,44.8564,69.7852,44.8564
                L69.7852,44.8564z"/>
        </g>
        <g>
            <path fill="#000000" d="M30.2139,44.8564c-0.5523,0-1-0.4472-1-1v-4.9443c0-1.001,0-1.001,4.8213-1.001c0.5522,0,1,0.4473,1,1
                c0,0.5528-0.4478,1-1,1c0.0058,0.0049-1.6914,0-2.8213,0v3.9453C31.2139,44.4092,30.7661,44.8564,30.2139,44.8564
                L30.2139,44.8564z"/>
        </g>
    </g>
</g>
</svg>
`;

// This function will now be called inside the map
const generatePrinterIconDataUri = (backgroundColor) => {
    const itemSpecificSvgString = printerIconSvgTemplate.replace('{{ICON_BACKGROUND_COLOR}}', backgroundColor);
    const cleanedSvg = itemSpecificSvgString.replace(/<!--[\s\S]*?-->/g, '').replace(/\n/g, '').replace(/\s\s+/g, ' ');
    return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(cleanedSvg)}`;
};


const Default = ({
    modal,
    setModal,
    setEsRefresh,
    onImprimir,
    onImprimirBienvenida,
    onImprimirDinamica,
    esImprimir,
    esImprimirDinamica
}) => {
    const alertSwal = withReactContent(Swal);
    const toggle = () => {
        if (setModal) {
            setModal((s) => ({ ...s, estado: !s.estado }))
        }
    }

    const [previewModal, setPreviewModal] = useState({ visible: false, content: '', data: null, fontSizeName: 25, fontSizeLastName: 20, fontSizeCompany: 14, generateEtiquetaHtml: null, isModified: false }); // Add state for preview modal

    const capitalizeFirstLetter = (text) => {
        return text ? text
            .toLowerCase()
            .split(' ')
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ') : '';
    };

    const onClickRefresh = () => {
        setEsRefresh((s) => !s)
    }

    const onPreviewEtiqueta = (data) => {
        const aplicaQrFrontal = false;
        const aplicaDobleEtiqueta = [1, 15, 13, 3, 8, 7].includes(data?.TIPO_CARNET);
        const aplicaEmpresa = [1, 2, 3, 4, 5, 6, 9, 12, 15, 16, 7].includes(data?.TIPO_CARNET);
        const aplicaMesaSillasFrontal = false;
        const aplicaDescSoloCena = data?.TIPO_CARNET === 8;
        const etiquetaTipoCarnet = [6, 18, 19].includes(Number(data?.TIPO_CARNET))
            ? [data?.TIPO_SUBCARNET, Number(data?.TIPO_CARNET) === 6 ? 'STAFF' : 'PROVEEDOR'].filter(Boolean).join(' - ')
            : data?.TIPO_SUBCARNET;

        // Default logic for determining text sizes
        let etiquetaNombres = 1;
        let etiquetaApellidos = 1;
        let etiquetaEmpresa = 1;

        if (data?.NOMBRES_DP?.length >= 17 && data?.NOMBRES_DP?.length < 43) {
            etiquetaNombres = 2;
        } else if (data?.NOMBRES_DP?.length >= 43) {
            etiquetaNombres = 3;
        }

        if (data?.APELLIDOS_DP?.length > 25 && data?.APELLIDOS_DP?.length < 43) {
            etiquetaApellidos = 2;
        }

        if (data?.EMPRESA?.length > 25 && data?.EMPRESA?.length < 43) {
            etiquetaEmpresa = 2;
        } else if (data?.EMPRESA?.length >= 43) {
            etiquetaEmpresa = 3;
        }

        const generateEtiquetaHtml = (fontSizeName, fontSizeLastName, fontSizeCompany) => `
            <html>
                <head>
                    <title>Etiqueta Preview</title>
                    <style>
                        * { margin: 0; padding: 0; }
                        html, body { height: 100%; margin: 0; padding: 0; word-break: break-all; zoom: 1; }
                        .contenedor { 
                            display: flex; 
                            text-align: center; 
                            justify-content: center; 
                            align-items: flex-start; 
                            overflow: hidden; 
                            width: 57mm;
                            height: 20mm;
                            text-transform: lowercase; 
                            border: 3px dashed #ccc; 
                        }
                        .texto { 
                            font-family: Arial, Helvetica, sans-serif; 
                            font-size: 3mm; 
                            text-transform: capitalize; 
                            display: flex; 
                            flex-direction: column; 
                            justify-content: ${!aplicaEmpresa || !data?.EMPRESA ? 'center' : 'flex-start'}; 
                            align-items: center; 
                            height: 100%;
                            padding-top: 5px;    
                        }
                        #containerText {
                            background-color: white; 
                            display: flex;
                            justify-content: center;
                            align-items: flex-start; 
                            width: 100%;
                            height: 100%;
                        }

                        h1 { font-size: ${fontSizeName}px; }
                        h3 { font-size: ${fontSizeLastName}px; }
                        p { font-size: ${fontSizeCompany}px; text-transform: uppercase; letter-spacing: 0.5px; }
                    </style>
                </head>
                
                <body style="margin: 0; padding: 0; display: flex; justify-content: center; align-items: center; height: 100%;">
                    <div class="contenedor">
                        ${aplicaQrFrontal ? `
                            <div id="qr" style="width:20%;height:100%;">
                                <img src="${data?.img}" width="70" height="70" />
                            </div>
                        ` : ''}
                        <div id="containerText">
                            <span class="texto">
                                <h1>${data?.NOMBRES_DP ? capitalizeFirstLetter(data?.NOMBRES_DP) : ''}</h1>
                                <h3>${data?.APELLIDOS_DP ? capitalizeFirstLetter(data?.APELLIDOS_DP) : ''}</h3>
                                ${aplicaEmpresa && data?.EMPRESA ? `<p>${data?.EMPRESA}</p>` : ''}
                                ${etiquetaTipoCarnet ? `<p style="font-size: 10px;">${etiquetaTipoCarnet}</p>` : ''}
                                ${aplicaDescSoloCena ? `<p>Solo Cena</p>` : ''}
                            </span>
                        </div>
                    </div>
                </body>
            </html>
        `;

        // Determine default font sizes based on logic
        const defaultFontSizeName = etiquetaTipoCarnet
            ? (etiquetaNombres === 1 ? 19 : etiquetaNombres === 2 ? 16 : 13)
            : (etiquetaNombres === 1 ? 22 : etiquetaNombres === 2 ? 18 : 14);
        const defaultFontSizeLastName = etiquetaApellidos === 1 ? 20 : 15;
        const defaultFontSizeCompany = etiquetaEmpresa === 1 ? 14 : etiquetaEmpresa === 2 ? 8 : 6;

        setPreviewModal({
            visible: true,
            content: generateEtiquetaHtml(defaultFontSizeName, defaultFontSizeLastName, defaultFontSizeCompany),
            data,
            fontSizeName: defaultFontSizeName,
            fontSizeLastName: defaultFontSizeLastName,
            fontSizeCompany: defaultFontSizeCompany,
            generateEtiquetaHtml,
            isModified: false, // Track if any size is modified
        });
    };

    const printPreview = async () => {
        if (!previewModal?.data) return;

    // Igual que Expogas: considerar tanto IMPRIMIO_CARNET_RAC como IMPRIMIO_CARNET_TEXT
    const esReimpresion = previewModal.data?.IMPRIMIO_CARNET_RAC === 1 || previewModal.data?.IMPRIMIO_CARNET_RAC === true || previewModal.data?.IMPRIMIO_CARNET_TEXT === 'Impreso' || previewModal.data?.IMPRIMIO_CARNET_TEXT === 'CARNET IMPRESO';
    const noPagado = previewModal.data.ESTATUS_DPG !== 2 && previewModal.data.ESTATUS_DPG !== 4 && previewModal.data.ESTATUS_DPG !== 5;

    // Pedir motivo si: 1) No está pagado (sin pagar/pendiente), o 2) Es una reimpresión  
    // No se pide motivo para: pagado (2), no aplica (4), cortesía (5)
    if (noPagado || esReimpresion) {
            let tituloModal = '';
            let textoModal = '';
            let placeholderTexto = '';
            
            if (esReimpresion) {
                tituloModal = '¡Reimpresión!';
                textoModal = `Este carnet ya fue impreso anteriormente. Se guardará un registro del motivo de reimpresión.`;
                placeholderTexto = 'Motivo de la reimpresión (ej: carnet dañado, perdido, etc.)';
            } else {
                tituloModal = '¡Atención!';
                textoModal = `Este registro tiene estatus de pago: "${previewModal.data.ESTATUS_DPG_TEXT}". ¿Estás seguro de que deseas imprimir un registro sin pagar?`;
                placeholderTexto = 'Motivo por el que se desea imprimir sin pagar';
            }

            const { value: motivo, isConfirmed } = await alertSwal.fire({
                title: tituloModal,
                text: textoModal,
                icon: esReimpresion ? 'info' : 'warning',
                showCancelButton: true,
                confirmButtonText: esReimpresion ? 'Reimprimir' : 'Sí, imprimir',
                cancelButtonText: 'Cancelar',
                confirmButtonColor: esReimpresion ? '#17a2b8' : '#3085d6',
                cancelButtonColor: '#d33',
                input: 'text',
                inputLabel: 'Motivo requerido',
                inputPlaceholder: placeholderTexto,
                inputValidator: (value) => {
                    if (!value || value.trim() === '') {
                        return 'Debe ingresar un motivo';
                    }
                    return null;
                },
                didOpen: () => {
                    const confirmBtn = Swal.getConfirmButton();
                    const input = Swal.getInput();
                    confirmBtn.disabled = true;
                    input.addEventListener('input', function() {
                        confirmBtn.disabled = !input.value.trim();
                    });
                }
            });
            
            if (!isConfirmed) return;
            
            // Preparar datos con información adicional
            const printData = {
                ...previewModal.data,
                fontSizeName: previewModal?.fontSizeName,
                fontSizeLastName: previewModal?.fontSizeLastName,
                fontSizeCompany: previewModal?.fontSizeCompany,
                motivo_impresion: motivo,
                COMENTARIO_IMPRESION_RAC: motivo,
                es_reimpresion: esReimpresion,
                tipo_impresion: esReimpresion ? 'reimpresion' : (noPagado ? 'primera_impresion_sin_pagar' : 'primera_impresion')
            };
            
            await onImprimir(printData);
            
            setModal((s) => ({
                ...s,
                datos: s.datos.map((item) => 
                    item.ID_RAC === previewModal.data.ID_RAC 
                        ? { ...item, IMPRIMIO_CARNET_RAC: 1 }
                        : item
                )
            }));
            
            setPreviewModal((prev) => ({
                ...prev,
                data: { ...prev.data, IMPRIMIO_CARNET_RAC: 1 }
            }));
            
            return;
        }
        
        const printData = {
            ...previewModal.data,
            fontSizeName: previewModal?.fontSizeName,
            fontSizeLastName: previewModal?.fontSizeLastName,
            fontSizeCompany: previewModal?.fontSizeCompany,
            es_reimpresion: false,
            tipo_impresion: 'primera_impresion'
        };
        await onImprimir(printData);
        
        setModal((s) => ({
            ...s,
            datos: s.datos.map((item) => 
                item.ID_RAC === previewModal.data.ID_RAC 
                    ? { ...item, IMPRIMIO_CARNET_RAC: 1 }
                    : item
            )
        }));
        
        setPreviewModal((prev) => ({
            ...prev,
            data: { ...prev.data, IMPRIMIO_CARNET_RAC: 1 }
        }));
    };

    useEffect(() => {
        let isS = true
        return () => isS = false
    }, [])
    
    return (
        <Fragment>
            <Modal
                className={`modal-body`}
                isOpen={modal.estado}
                toggle={toggle}
                centered={true}
                size={'lg'}
                style={{ maxWidth: '70em', width: '80%', padding: 0 }}
            >
                {/* <ModalHeader toggle={toggle}><div style={{ fontSize: 20 }}>Impresión de Carnet</div></ModalHeader> */}
                <div class="modal-header">
                    <h5 class="modal-title">
                        <div style={{fontSize: 20}}>Impresión de Carnet</div>
                    </h5>
                    <button type="button" class="close" aria-label="Close" onClick={() => toggle()} style={{ outline: "none", userSelect: "none" }}>
                        <span aria-hidden="true">×</span>
                    </button>
                </div>
                <ModalBody>
                    {/* <div className="datatable-react mt-4 d-flex justify-content-center">
                        <div className="col-sm-12 ">
                            <div> */}
                                <div className="row">
                                    <div className="col-12">
                                        <form className="col-md-12" id={`formCarnet`}>
                                            <div className="row">
                                                <div className="col-12">
                                                    <div className="carnet-body">
                                                        {modal.datos.map((v, i) => {
                                                            const fontSizeName = v?.NOMBRES_DP?.length > 43 ? 15 : v?.NOMBRES_DP?.length > 17 ? 20 : 25;
                                                            const fontSizeLastName = v?.APELLIDOS_DP?.length > 43 ? 15 : v?.APELLIDOS_DP?.length > 25 ? 15 : 20;
                                                            const fontSizeCompany = v?.EMPRESA?.length > 43 ? 6 : v?.EMPRESA?.length > 25 ? 8 : 14;

                                                            return (
                                                            <div className="row" key={'imp'+i}>
                                                                <div className='col-md-12'>
                                                                    {(v?.TIPO_SUBCARNET || [6, 18, 19].includes(Number(v?.TIPO_CARNET))) && (
                                                                        <div className="mb-2">
                                                                            {v?.TIPO_SUBCARNET && <span className="badge badge-primary mr-2">{v.TIPO_SUBCARNET}</span>}
                                                                            {[6, 18, 19].includes(Number(v?.TIPO_CARNET)) && (
                                                                                <span className="badge badge-primary">{Number(v.TIPO_CARNET) === 6 ? 'STAFF' : 'PROVEEDOR'}</span>
                                                                            )}
                                                                        </div>
                                                                    )}
                                                                    <div className='row' style={{ display: 'flex', flexWrap: 'wrap' }}>
                                                                        <div className="col-md-4 mb-0 pb-0" style={{height: '30%'}}>
                                                                            <div className="form-group mb-0 pb-0">
                                                                                <label
                                                                                    style={{ fontWeight: 600 }}
                                                                                    htmlFor="pnombre"
                                                                                >
                                                                                <span className='mr-2'><strong>{(i + 1)}</strong>.-</span> Nombre(s)<span className="text-danger">*</span>
                                                                                </label>
                                                                                <input
                                                                                    className="form-control border border-dark"
                                                                                    type="text"
                                                                                    // id={`txtNombre`} 
                                                                                    name="txtNombre"
                                                                                    placeholder="Nombre(s)"
                                                                                    value={v?.NOMBRES_DP}
                                                                                    onChange={(e) => {
                                                                                        e.persist()
                                                                                        setModal((s) => ({
                                                                                            ...s,
                                                                                            datos: s.datos.map((k, l) => l === i? ({...k, NOMBRES_DP: e.target.value}): k)
                                                                                        }))
                                                                                    }}
                                                                                />
                                                                                <span className={`text-danger txtVacios txtNombre`} style={{ display: 'none' }}>Falta completar (Nombre(s))</span>
                                                                            </div>
                                                                        </div>
                                                                        <div className="col-md-4 mb-0 pb-0" style={{height: '30%'}}>
                                                                            <div className="form-group mb-0 pb-0">
                                                                                <label
                                                                                    style={{ fontWeight: 600 }}
                                                                                    htmlFor="papellidos"
                                                                                >
                                                                                    Apellidos<span className="text-danger">*</span>
                                                                                </label>
                                                                                <input
                                                                                    className="form-control border border-dark"
                                                                                    // defaultValue={datos.APELLIDOS_DP}
                                                                                    // id={`txtApellidos`} 
                                                                                    name="txtApellidos"
                                                                                    type="text"
                                                                                    placeholder="Apellidos"
                                                                                    value={v?.APELLIDOS_DP}
                                                                                    onChange={(e) => {
                                                                                        e.persist()
                                                                                        setModal((s) => ({
                                                                                            ...s,
                                                                                            datos: s.datos.map((k, l) => l === i? ({...k, APELLIDOS_DP: e.target.value}): k)
                                                                                        }))
                                                                                    }}
                                                                                />
                                                                                <span className={`text-danger txtVacios txtApellidos`} style={{ display: 'none' }}>Falta completar Apellidos</span>
                                                                            </div>
                                                                        </div>
                                                                        <div className="col-md-8 mb-1 pb-0" style={{ order: 1, width: '100%' }}>
                                                                            <div className="form-group mb-0 pb-0">
                                                                                <label
                                                                                    style={{ fontWeight: 600 }}
                                                                                    htmlFor="pempresa"
                                                                                >
                                                                                    Empresa
                                                                                </label>
                                                                                <input
                                                                                    className="form-control border border-dark"
                                                                                    type="text"
                                                                                    name="txtEmpresa"
                                                                                    placeholder="Empresa"
                                                                                    value={v?.EMPRESA || ''}
                                                                                    onChange={(e) => {
                                                                                        e.persist()
                                                                                        setModal((s) => ({
                                                                                            ...s,
                                                                                            datos: s.datos.map((k, l) => l === i? ({...k, EMPRESA: e.target.value}): k)
                                                                                        }))
                                                                                    }}
                                                                                />
                                                                                <span className={`text-danger txtVacios txtEmpresa`} style={{ display: 'none' }}>Falta completar Empresa</span>
                                                                            </div>
                                                                        </div>
                                                                        <div className="col-md-2 mb-0 pb-0 text-center" style={{ order: 2 }}>
                                                                            <label style={{ fontWeight: 600 }}></label>
                                                                            <div className="form-group pb-0 mb-0" 
                                                                            style={{cursor: 'pointer', transform: 'translateY(-50px)'}}>
                                                                                {!(esImprimir == v?.ID_RAC)?
                                                                                    <img 
                                                                                        src={generatePrinterIconDataUri(v?.IMPRIMIO_CARNET_RAC ? 'red' : '#FFFFFF')} 
                                                                                        width={50} 
                                                                                        alt="Imprimir" 
                                                                                        onClick={async (e) => {
                                                                                            e.stopPropagation();
                                                                                            // Verificar si es una reimpresión (ya se ha impreso antes)
                                                                                            const esReimpresion = v?.IMPRIMIO_CARNET_RAC === 1 || v?.IMPRIMIO_CARNET_RAC === true || v?.IMPRIMIO_CARNET_TEXT === 'Impreso' || v?.IMPRIMIO_CARNET_TEXT === 'CARNET IMPRESO';
                                                                                            const noPagado = v.ESTATUS_DPG !== 2 && v.ESTATUS_DPG !== 4 && v.ESTATUS_DPG !== 5;
                                                                                            // Pedir motivo si: 1) No está pagado (sin pagar/pendiente), o 2) Es una reimpresión
                                                                                            // No se pide motivo para: pagado (2), no aplica (4), cortesía (5)
                                                                                            if (noPagado || esReimpresion) {
                                                                                                let tituloModal = '';
                                                                                                let textoModal = '';
                                                                                                let placeholderTexto = '';
                                                                                                
                                                                                                if (esReimpresion) {
                                                                                                    tituloModal = '¡Reimpresión!';
                                                                                                    textoModal = `Este carnet ya fue impreso anteriormente. Se guardará un registro del motivo de reimpresión.`;
                                                                                                    placeholderTexto = 'Motivo de la reimpresión (ej: carnet dañado, perdido, etc.)';
                                                                                                } else {
                                                                                                    tituloModal = '¡Atención!';
                                                                                                    textoModal = `Este registro tiene estatus de pago: "${v.ESTATUS_DPG_TEXT}". ¿Estás seguro de que deseas imprimir un registro sin pagar?`;
                                                                                                    placeholderTexto = 'Motivo por el que se desea imprimir sin pagar';
                                                                                                }
                                                                                                
                                                                                                const { value: motivo, isConfirmed } = await alertSwal.fire({
                                                                                                    title: tituloModal,
                                                                                                    text: textoModal,
                                                                                                    icon: esReimpresion ? 'info' : 'warning',
                                                                                                    showCancelButton: true,
                                                                                                    confirmButtonText: esReimpresion ? 'Reimprimir' : 'Sí, imprimir',
                                                                                                    cancelButtonText: 'Cancelar',
                                                                                                    confirmButtonColor: esReimpresion ? '#17a2b8' : '#3085d6',
                                                                                                    cancelButtonColor: '#d33',
                                                                                                    input: 'text',
                                                                                                    inputLabel: 'Motivo requerido',
                                                                                                    inputPlaceholder: placeholderTexto,
                                                                                                    inputValidator: (value) => {
                                                                                                        if (!value || value.trim() === '') {
                                                                                                            return 'Debe ingresar un motivo';
                                                                                                        }
                                                                                                        return null;
                                                                                                    },
                                                                                                    allowOutsideClick: () => !Swal.isLoading(),
                                                                                                    preConfirm: (motivo) => {
                                                                                                        if (!motivo || motivo.trim() === '') {
                                                                                                            Swal.showValidationMessage('Debe ingresar un motivo');
                                                                                                            return false;
                                                                                                        }
                                                                                                        return motivo.trim();
                                                                                                    },
                                                                                                    didOpen: () => {
                                                                                                        const confirmBtn = Swal.getConfirmButton();
                                                                                                        const input = Swal.getInput();
                                                                                                        confirmBtn.disabled = true;
                                                                                                        input.addEventListener('input', function() {
                                                                                                            confirmBtn.disabled = !input.value.trim();
                                                                                                        });
                                                                                                    }
                                                                                                });
                                                                                                
                                                                                                if (!isConfirmed) return;
                                                                                                
                                                                                                // Preparar datos con información adicional
                                                                                                const datosImpresion = { 
                                                                                                    ...v, 
                                                                                                    motivo_impresion: motivo, 
                                                                                                    COMENTARIO_IMPRESION_RAC: motivo,
                                                                                                    es_reimpresion: esReimpresion,
                                                                                                    tipo_impresion: esReimpresion ? 'reimpresion' : (noPagado ? 'primera_impresion_sin_pagar' : 'primera_impresion')
                                                                                                };
                                                                                                
                                                                                                await onImprimir(datosImpresion);
                                                                                                
                                                                                                setModal((s) => ({
                                                                                                    ...s,
                                                                                                    datos: s.datos.map((item) => 
                                                                                                        item.ID_RAC === v.ID_RAC 
                                                                                                            ? { ...item, IMPRIMIO_CARNET_RAC: 1 }
                                                                                                            : item
                                                                                                    )
                                                                                                }));
                                                                                            } else {
                                                                                                await onImprimir({
                                                                                                    ...v,
                                                                                                    es_reimpresion: false,
                                                                                                    tipo_impresion: 'primera_impresion'
                                                                                                });
                                                                                                
                                                                                                setModal((s) => ({
                                                                                                    ...s,
                                                                                                    datos: s.datos.map((item) => 
                                                                                                        item.ID_RAC === v.ID_RAC 
                                                                                                            ? { ...item, IMPRIMIO_CARNET_RAC: 1 }
                                                                                                            : item
                                                                                                    )
                                                                                                }));
                                                                                            }
                                                                                        }}
                                                                                    />
                                                                                    :
                                                                                    <img src='/loading.gif' width={50} alt="Cargando" />
                                                                                }
                                                                                <br/>{v?.IMPRIMIO_CARNET_RAC ? 'Ya impreso' : 'Por imprimir'}
                                                                            </div>
                                                                        </div>
                                                                        <div className="col-md-2 mb-0 pb-0 text-center" style={{ order: 3 }}>
                                                                            <label style={{ fontWeight: 600 }}></label>
                                                                            <div className="form-group pb-0 mb-0" onClick={() => onPreviewEtiqueta(v)} style={{ cursor: 'pointer', transform: 'translateY(-50px)' }}>
                                                                                {/* <img src='/preview.png' width={50} /> */}
                                                                                <br />
                                                                                <i className="fa fa-eye" style={{ fontSize: '1.2em', marginTop: '5px' }}></i> {/* Add eye icon */}
                                                                                <br />Preview
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                {v?.CONTEO_IMPRESION?
                                                                <div className="col-md-12 mb-2 mt-1" style={{fontSize: 12}}>
                                                                    Fecha impresión: {v?.ULTIMA_IMPRESION}
                                                                </div>: ''}
                                                                {/* Agregar línea separadora entre registros si hay más de uno */}
                                                                {modal.datos.length > 1 && i < modal.datos.length - 1 && (
                                                                    <div className="col-md-12 mb-3 mt-2">
                                                                        <hr style={{ borderTop: '1px solid #dee2e6', margin: '10px 0' }} />
                                                                    </div>
                                                                )}
                                                            </div>)})
}                                                   </div>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            {/* </div>
                        </div>
                    </div> */}
                </ModalBody>
                <ModalFooter>
                    {/* <Button color="primary" onClick={() => null}
                    >Guardar</Button> */}
                    <Button color="danger" onClick={toggle}
                    >Cerrar</Button>
                </ModalFooter>
            </Modal>
            {previewModal?.visible && (
                <Modal
                    isOpen={previewModal?.visible}
                    toggle={() => setPreviewModal({ visible: false, content: '', data: null })}
                    centered={true}
                    size="md" // Keep the modal smaller
                    style={{ maxWidth: '40em', width: '50%', padding: 0 }} // Adjust width and maxWidth
                >
                    <ModalHeader toggle={() => setPreviewModal({ visible: false, content: '', data: null })}>
                        <div style={{ fontSize: 20, textAlign: 'left', width: '100%' }}>Preview</div> {/* Align the title to the left */}
                    </ModalHeader>
                    <ModalBody style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}> {/* Center content */}
                        <iframe
                            srcDoc={previewModal?.content}
                            style={{ width: '100%', height: '200px', border: 'none', marginBottom: '20px' }} // Adjust height
                        ></iframe>
                        <div className="font-config">
                            <div className="row">
                                <div className="col-md-4">
                                    <label style={{ fontWeight: 600 }}>Tamaño de letra - Nombre</label>
                                    <input
                                        type="number"
                                        className="form-control"
                                        value={previewModal?.fontSizeName}
                                        onChange={(e) => {
                                            const newFontSize = e.target.value;
                                            setPreviewModal((prev) => ({
                                                ...prev,
                                                fontSizeName: newFontSize,
                                                content: prev.generateEtiquetaHtml(newFontSize, prev?.fontSizeLastName, prev?.fontSizeCompany),
                                                isModified: true, // Mark as modified
                                            }));
                                        }}
                                    />
                                </div>
                                <div className="col-md-4">
                                    <label style={{ fontWeight: 600 }}>Tamaño de letra - Apellidos</label>
                                    <input
                                        type="number"
                                        className="form-control"
                                        value={previewModal?.fontSizeLastName}
                                        onChange={(e) => {
                                            const newFontSize = e.target.value;
                                            setPreviewModal((prev) => ({
                                                ...prev,
                                                fontSizeLastName: newFontSize,
                                                content: prev.generateEtiquetaHtml(prev?.fontSizeName, newFontSize, prev?.fontSizeCompany),
                                                isModified: true, // Mark as modified
                                            }));
                                        }}
                                    />
                                </div>
                                <div className="col-md-4">
                                    <label style={{ fontWeight: 600 }}>Tamaño de letra - Empresa</label>
                                    <input
                                        type="number"
                                        className="form-control"
                                        value={previewModal?.fontSizeCompany}
                                        onChange={(e) => {
                                            const newFontSize = e.target.value;
                                            setPreviewModal((prev) => ({
                                                ...prev,
                                                fontSizeCompany: newFontSize,
                                                content: prev.generateEtiquetaHtml(prev?.fontSizeName, prev?.fontSizeLastName, newFontSize),
                                                isModified: true, // Mark as modified
                                            }));
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="primary" onClick={printPreview}>
                            Imprimir
                        </Button>
                        <Button color="danger" onClick={() => setPreviewModal({ visible: false, content: '', data: null })}>
                            Cerrar
                        </Button>
                    </ModalFooter>
                </Modal>
            )}
        </Fragment>
    )
}

export default Default

